import React from 'react'
import Chip from '@material-ui/core/Chip'
import CheckIcon from 'components/material-symbol/icons/Check'
import AddIcon from 'components/material-symbol/icons/Add'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { ALL_AGE_GROUP_TAGS, MAX_TAGS } from 'utils/groupEventUtils'

const useStyles = makeStyles(() => ({
  tag: {
    margin: '5px',
    width: 'fit-content',
    fontWeight: 500,
  },
  tagUnselected: {
    backgroundColor: 'transparent',
    border: '1px solid #70787C',
    color: '#40484C',
    '& .MuiChip-icon': {
      color: '#40484C',
    },
    '& .MuiChip-label': {
      color: '#40484C',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  tagSelected: {
    backgroundColor: '#EBF0F2',
    border: '1px solid #EBF0F2',
    color: '#172024',
    '& .MuiChip-icon, & .MuiChip-icon .MuiSvgIcon-root': {
      color: '#0053FF',
    },
    '& .MuiChip-label': {
      color: '#172024',
    },
    '&:hover': {
      backgroundColor: '#EBF0F2',
    },
    '&:focus': {
      backgroundColor: '#EBF0F2',
    },
  },
}))
const immutableTags = ['PGA HOPE', ...ALL_AGE_GROUP_TAGS]

const TagSelectionInput = ({
  tags,
  value,
  onChange,
  allowToSelectImmutableTags,
}) => {
  const classes = useStyles()
  const onClick = tag => {
    if (value.includes(tag)) {
      onChange(value.filter(t => t !== tag))
    } else {
      const nonAgeGroupTags = value.filter(
        tag => !ALL_AGE_GROUP_TAGS.includes(tag),
      )
      return nonAgeGroupTags.length >= MAX_TAGS
        ? null
        : onChange([...value, tag])
    }
  }
  // the tag is included in the immutableTags array
  // then we only want to set it on event creation
  const isImmutableTag = tag => immutableTags.includes(tag)

  return (
    <>
      {tags.map(tag => {
        const isSelected = value.includes(tag)
        return (
          <Chip
            key={tag}
            icon={isSelected ? <CheckIcon htmlColor="#0053FF" /> : <AddIcon />}
            variant={isSelected ? 'default' : 'outlined'}
            label={tag}
            onClick={() =>
              isImmutableTag(tag) && !allowToSelectImmutableTags
                ? null
                : onClick(tag)
            }
            className={clsx(
              classes.tag,
              isSelected ? classes.tagSelected : classes.tagUnselected,
            )}
          />
        )
      })}
    </>
  )
}

export default TagSelectionInput
